import { BaseTableRows } from 'shell/components/shared/table/types';
import { Order } from 'shell/view-models/order';
import { DateTime } from 'luxon';
import { ReleasedService } from 'shell/models/certificate';
import { ReactElement } from 'react';

export interface CertificateClient extends BaseTableRows {
  serviceNumber: string;
  key: { codiceSiglaRegistro: string; idAnnoDocumento: string; progressivoDocumento: string };
  type: string;
  release: string;
  price: number;
  fiscalCode: string;
  certificateDate: string;
  certificateTime: string;
  operator: string;
  codeOperator?: string;
  releaseOperatorCode?: string;
  paymentType: string;
  serviceCode: string;
  ann: string;
  action?: ReactElement;
  typeCode?: string;
  item?: ReleasedService;
}

export interface CertificateResponse {
  list?: CertificateClient[];
  count?: number;
}

export enum SearchType {
  Generic = 'generic',
  Person = 'person',
}

export interface FiltersFormCertificate {
  fiscalCode?: string;
  surname?: string;
  withoutSurname?: boolean;
  name?: string;
  withoutName?: boolean;
  searchType?: SearchType;
  acronym?: string;
  year?: string;
  progressive?: string;
  certificateType?: string;
  release?: boolean;
  void?: string;
  payment?: string;
  service?: string;
  serviceDesc?: string;
  operator?: string;
  operatorDesc?: string;
  dateFrom?: DateTime | null;
  dateTo?: DateTime | null;
  dateFromVoid?: DateTime | null;
  dateToVoid?: DateTime | null;
  page?: number;
  rowsPerPage?: number;
  orders?: Order;
}
